import { css } from '@emotion/react';
import { LobbyGamePlayer } from '../../../graphql/types';
import StatusBadge from './MatchView/MatchmakingButton/InviteUser/StatusBadge';

interface Props {
  player: LobbyGamePlayer;
}

const PlayerView = ({ player }: Props) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
      `}
    >
      {player.name}
      {player.user != null && <StatusBadge status={player.user.onlineStatus} />}
    </div>
  );
};

export default PlayerView;
